import { CareTeamSlaView } from './CareTeamSlaView';
import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useUserInfo } from '@xolv-mybrightlink/common';

type MessageSlaFirstPageProps = {
  onLater: () => void;
  onContinue: () => void;
};

const CareTeamSlaFirstPageAction = (props: MessageSlaFirstPageProps) => {
  return (
    <Box sx={{ display: 'flex', width: '100%', fontSize: 16 }}>
      <Button
        variant={'outlined'}
        disableElevation
        onClick={props.onLater}
        sx={{
          width: '100%',
          borderRadius: 8,
          px: 11,
          mr: 4,
          py: 4,
          fontSize: 'inherit',
        }}
      >
        <FormattedMessage id='action.sla.later' />
      </Button>
      <Button
        variant={'contained'}
        disableElevation
        onClick={props.onContinue}
        sx={{
          width: '100%',
          borderRadius: 8,
          ml: 4,
          px: 11,
          py: 4,
          fontSize: 'inherit',
        }}
      >
        <FormattedMessage id='action.sla.continue' />
      </Button>
    </Box>
  );
};

export const CareTeamSlaFirstPage = (props: MessageSlaFirstPageProps) => {
  const userInfo = useUserInfo();
  const textPrefix = userInfo.hasPilotEligibleClient ? 'provider' : 'ccm';
  return (
    <CareTeamSlaView
      illustration='/public/assets/images/sla-1.svg'
      titleTextId='care-team.sla-1.title'
      descriptionTextIds={[`care-team.sla-1.${textPrefix}.description`]}
      action={<CareTeamSlaFirstPageAction {...props} />}
    />
  );
};
